import { UnitedStates } from '@occc-app/lib/constants';

import { StateSingleAutocompleteFormValues, UnitedState } from './types';

export const getStateSingleAutocompleteInitialValues = (
  stateId: string,
): StateSingleAutocompleteFormValues =>
  // Return the initial value for the state with the given `stateId` if BE sending something different than UtitedStates item.
  // Needed to improve user experience by avoiding an empty state.
  UnitedStates.find((state) => state.id === stateId) || { id: stateId, text: stateId };

export const useStatesQuery = () => {
  return {
    executeQuery: () => null,
    response: UnitedStates,
  };
};
export const mapStatesQueryResponseToRawArray = (response: UnitedState[]) => response;
export const mapRawStatesResponseItemToAutocompleteOption = (item: UnitedState) => ({
  value: item.id,
  label: item.text,
  _raw: item,
});
